// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --black: #000;
  --white: #fff;
  --primary-color: #2b80ff;
  --secondary-color: #e7e7e7;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (min-width: 991.98px) {
  .sidebar {
    display: none !important;
  }
  .main-panel {
    width: 100% !important;
  }
  .navbar .navbar-brand-wrapper .navbar-toggler {
    display: none !important;
  }
}

.userHide {
  display: none !important;
}

@media (max-width: 768px) {
  .userHide {
    display: unset !important;
  }
}

.dataTables_wrapper {
  padding-left: 0;
  padding-right: 0;
}
div.dataTables_wrapper div.dataTables_length select {
  width: auto;
  display: inline-block;
}

.dataTables_wrapper .dataTables_length select {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.dataTables_wrapper select {
  padding: 0.4rem;
  outline-offset: -2px;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^="col-"]:first-child {
  padding-left: 0;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 0.85em;
  white-space: nowrap;
  font-weight: 600;
}

.dataTables_wrapper .dataTables_info {
  font-size: 0.875rem;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^="col-"]:last-child {
  padding-right: 0;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 1px;
  white-space: nowrap;
  justify-content: flex-end;
}

.pagination,
.jsgrid .jsgrid-pager {
  display: flex;
  padding-left: 0;
  list-style: none;
}
.dataTables_wrapper .dataTables_paginate {
  margin-top: 20px;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0rem !important;
  border-bottom-right-radius: 0rem !important;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0rem !important;
  border-bottom-left-radius: 0rem !important;
}

.page-link:focus {
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 0%);
}

.page-link {
  padding: 0.5rem 0.75rem;
  line-height: 1 !important;
  color: #007bff;
}
.recharts-wrapper svg {
  overflow: visible;
  vertical-align: middle;
}

.manageLinkTable .dropdown .dropdown-toggle:after {
  content: none;
}

.recharts-brush-texts {
  font-size: 12px;
}

@media (max-width: 602px) {
  .graphCard {
    height: 900px !important;
  }
}
@media (max-width: 450px) {
  .graphCard {
    height: 950px !important;
  }
}

.toggle-input {
  display: none;
}

.toggle-label {
  display: inline-block;
  width: 40px;
  height: 20px;
  background-color: #c1c1c1;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.4s ease-in-out;
}

.toggle-input:checked + .toggle-label {
  background-color: #4caf50;
}

.toggle-label::before {
  content: "";
  width: 18px;
  height: 18px;
  background-color: white;
  border-radius: 50%;
  box-shadow: -0.5px 0.1px #00000011, -1px 0 0.25em #000000;
  position: absolute;
  top: 1px;
  left: 1px;
  transition: 0.2s;
}

.toggle-input:checked + .toggle-label::before {
  left: calc(100% - 19px);
}

.green-dot {
  width: 10px;
  height: 10px;
  margin: 2px;
  background-color: #4caf50;
  border-radius: 50%; /* Makes it a circle */
}

.orange-dot {
  width: 10px;
  height: 10px;
  margin: 2px;
  background-color: orange;
  border-radius: 50%; /* Makes it a circle */
}

.red-dot {
  width: 10px;
  height: 10px;
  margin: 2px;
  background-color: red;
  border-radius: 50%; /* Makes it a circle */
}

.custom-tooltip {
  margin: 0px;
  padding: 10px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(204, 204, 204);
  white-space: nowrap;
}

.custom-tooltip ul{
  margin: 0px;
  padding: 0px;
  list-style: none;
  white-space: nowrap;
}

.ag-checkbox-input-wrapper::after {
  content: "\\f096" !important; /* Font Awesome code for unchecked checkbox */
  font-family: 'Font Awesome 5 Free'; /* Ensure the correct font family is used */
  color: var(--ag-checkbox-unchecked-color);
}

.ag-checkbox-input-wrapper.ag-checked::after {
  content: "\\f14a" !important; /* Font Awesome code for checked checkbox */
  font-family: 'Font Awesome 5 Free'; /* Ensure the correct font family is used */
  font-weight: 900; /* Adjust according to the icon library's requirements */
  color: var(--ag-checkbox-checked-color);
}

.ag-icon-filter::before {
  content: "\\f0b0" !important; /* Font Awesome code for filter icon */
  font-family: 'Font Awesome 5 Free'; /* Ensure the correct font family is used */
  font-weight: 600; /* Adjust according to the icon library's requirements */
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yDAAyD;EACzD,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B,EAAE,6CAA6C;EAC1E,kCAAkC,EAAE,2CAA2C;EAC/E,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B,EAAE,2CAA2C;EACxE,kCAAkC,EAAE,2CAA2C;EAC/E,gBAAgB,EAAE,wDAAwD;EAC1E,uCAAuC;AACzC;;AAEA;EACE,2BAA2B,EAAE,sCAAsC;EACnE,kCAAkC,EAAE,2CAA2C;EAC/E,gBAAgB,EAAE,wDAAwD;AAC5E","sourcesContent":[":root {\n  --black: #000;\n  --white: #fff;\n  --primary-color: #2b80ff;\n  --secondary-color: #e7e7e7;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (min-width: 991.98px) {\n  .sidebar {\n    display: none !important;\n  }\n  .main-panel {\n    width: 100% !important;\n  }\n  .navbar .navbar-brand-wrapper .navbar-toggler {\n    display: none !important;\n  }\n}\n\n.userHide {\n  display: none !important;\n}\n\n@media (max-width: 768px) {\n  .userHide {\n    display: unset !important;\n  }\n}\n\n.dataTables_wrapper {\n  padding-left: 0;\n  padding-right: 0;\n}\ndiv.dataTables_wrapper div.dataTables_length select {\n  width: auto;\n  display: inline-block;\n}\n\n.dataTables_wrapper .dataTables_length select {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.dataTables_wrapper select {\n  padding: 0.4rem;\n  outline-offset: -2px;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter {\n  text-align: right;\n}\n\ndiv.table-responsive\n  > div.dataTables_wrapper\n  > div.row\n  > div[class^=\"col-\"]:first-child {\n  padding-left: 0;\n}\n\ndiv.dataTables_wrapper div.dataTables_info {\n  padding-top: 0.85em;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.dataTables_wrapper .dataTables_info {\n  font-size: 0.875rem;\n}\n\ndiv.table-responsive > div.dataTables_wrapper > div.row {\n  margin: 0;\n}\n\ndiv.table-responsive\n  > div.dataTables_wrapper\n  > div.row\n  > div[class^=\"col-\"]:last-child {\n  padding-right: 0;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate {\n  margin: 0;\n  white-space: nowrap;\n  text-align: right;\n}\n\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  margin: 2px 1px;\n  white-space: nowrap;\n  justify-content: flex-end;\n}\n\n.pagination,\n.jsgrid .jsgrid-pager {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n.dataTables_wrapper .dataTables_paginate {\n  margin-top: 20px;\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 0rem !important;\n  border-bottom-right-radius: 0rem !important;\n}\n\n.page-item:first-child .page-link {\n  border-top-left-radius: 0rem !important;\n  border-bottom-left-radius: 0rem !important;\n}\n\n.page-link:focus {\n  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 0%);\n}\n\n.page-link {\n  padding: 0.5rem 0.75rem;\n  line-height: 1 !important;\n  color: #007bff;\n}\n.recharts-wrapper svg {\n  overflow: visible;\n  vertical-align: middle;\n}\n\n.manageLinkTable .dropdown .dropdown-toggle:after {\n  content: none;\n}\n\n.recharts-brush-texts {\n  font-size: 12px;\n}\n\n@media (max-width: 602px) {\n  .graphCard {\n    height: 900px !important;\n  }\n}\n@media (max-width: 450px) {\n  .graphCard {\n    height: 950px !important;\n  }\n}\n\n.toggle-input {\n  display: none;\n}\n\n.toggle-label {\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n  background-color: #c1c1c1;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.4s ease-in-out;\n}\n\n.toggle-input:checked + .toggle-label {\n  background-color: #4caf50;\n}\n\n.toggle-label::before {\n  content: \"\";\n  width: 18px;\n  height: 18px;\n  background-color: white;\n  border-radius: 50%;\n  box-shadow: -0.5px 0.1px #00000011, -1px 0 0.25em #000000;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  transition: 0.2s;\n}\n\n.toggle-input:checked + .toggle-label::before {\n  left: calc(100% - 19px);\n}\n\n.green-dot {\n  width: 10px;\n  height: 10px;\n  margin: 2px;\n  background-color: #4caf50;\n  border-radius: 50%; /* Makes it a circle */\n}\n\n.orange-dot {\n  width: 10px;\n  height: 10px;\n  margin: 2px;\n  background-color: orange;\n  border-radius: 50%; /* Makes it a circle */\n}\n\n.red-dot {\n  width: 10px;\n  height: 10px;\n  margin: 2px;\n  background-color: red;\n  border-radius: 50%; /* Makes it a circle */\n}\n\n.custom-tooltip {\n  margin: 0px;\n  padding: 10px;\n  background-color: rgb(255, 255, 255);\n  border: 1px solid rgb(204, 204, 204);\n  white-space: nowrap;\n}\n\n.custom-tooltip ul{\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n  white-space: nowrap;\n}\n\n.ag-checkbox-input-wrapper::after {\n  content: \"\\f096\" !important; /* Font Awesome code for unchecked checkbox */\n  font-family: 'Font Awesome 5 Free'; /* Ensure the correct font family is used */\n  color: var(--ag-checkbox-unchecked-color);\n}\n\n.ag-checkbox-input-wrapper.ag-checked::after {\n  content: \"\\f14a\" !important; /* Font Awesome code for checked checkbox */\n  font-family: 'Font Awesome 5 Free'; /* Ensure the correct font family is used */\n  font-weight: 900; /* Adjust according to the icon library's requirements */\n  color: var(--ag-checkbox-checked-color);\n}\n\n.ag-icon-filter::before {\n  content: \"\\f0b0\" !important; /* Font Awesome code for filter icon */\n  font-family: 'Font Awesome 5 Free'; /* Ensure the correct font family is used */\n  font-weight: 600; /* Adjust according to the icon library's requirements */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
